import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Box, Grid } from '@mui/material';
import CustomModal from './CustomModal';
import ImgBox from '../Box/ImgBox';
import { CarouselArrows } from '../../carousel';
import Iconify from '../../Iconify';

ImgFullScreen.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  image: PropTypes.any,
  images: PropTypes.any,
  // loading: PropTypes.any,
};

export default function ImgFullScreen({ open, onClose, image, images }) {
  const [actualImg, setActualImg] = useState(image);

  const [loadingImage, setLoadingImage] = useState(true);

  useEffect(() => {
    setActualImg(image);
    setLoadingImage(false);
  }, [image]);

  useEffect(() => {
    setTimeout(() => {
      setLoadingImage(false);
    }, 500);
  }, [actualImg]);

  const handlePrevious = () => {
    if (actualImg > 0) {
      setLoadingImage(true);
      setActualImg(actualImg - 1);
    } else {
      setActualImg(images.length);
    }
  };

  const handleNext = () => {
    if (actualImg < images.length - 1) {
      setLoadingImage(true);
      setActualImg(actualImg + 1);
    } else {
      setActualImg(0);
    }
  };

  return (
    <CustomModal open={open} onClose={onClose}>
      <Box>
        <Grid container spacing={2}>
          <Grid xs={1} item />
          <Grid xs={10} item sx={{ position: 'relative' }}>
            <CarouselArrows filled onNext={handleNext} onPrevious={handlePrevious}>
              {!loadingImage ? (
                <ImgBox
                  className="border-radius-12"
                  src={
                    images[actualImg].imageKey !== undefined
                      ? `${process.env.REACT_APP_API_URL}/image/download/${images[actualImg].imageKey}?sizeIndex=0`
                      : ''
                  }
                  sx={{ width: '100%', height: '58vh', objectFit: 'contain !important' }}
                />
              ) : (
                <Box
                  sx={{
                    width: '100%',
                    height: '58vh',
                    display: 'flex',
                    alignItems: 'center', // Center vertically
                    justifyContent: 'center', // Center horizontally
                  }}
                >
                  <Iconify icon="eos-icons:three-dots-loading" color="#ffc425" width={44} height={44} />
                </Box>
              )}
            </CarouselArrows>
          </Grid>
        </Grid>
      </Box>
    </CustomModal>
  );
}
